module.exports = __webpack_public_path__ + "img/lineloginnew.a2bd0093.png";